<template>
    <div class="tw-mb-4">
        <h2 class="tw-capitalize uppercase tw-mb-3 tw-font-bold"><a :href="'mailto:'+model.email">{{ model.name }}</a></h2>
        <div class="tw-flex tw-items-left">
            <div v-html="model.html"></div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Committee',
    props: {
        modelProp: {
            type: Object,
            required: true
        }
    },
    computed: {
        //
    },
    data: function () {
        return {
            model: this.modelProp || null,
        }
    }

};
</script>
<style scoped>
.uppercase {
    text-transform: uppercase;
}
a {
    color: #0000EE;
    text-decoration: underline;
}
.description {
    font-size: 0.85em;
    margin: 0 0 3px 0;
    padding: 0;
}
</style>
